import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface DeleteConfirmDialogProps {
  open: boolean;
  employeeKey: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  employeeKey,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("paygap.employeeData.dialog.confirmDelete.title")}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("paygap.employeeData.dialog.confirmDelete.message")}
        </Typography>
        {employeeKey && (
          <Typography variant="body2" sx={{ mb: 2, fontWeight: "bold" }}>
            {t("paygap.employeeData.employeeKey", "Employee Key:")} {employeeKey}
          </Typography>
        )}
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>{t("paygap.employeeData.dialog.confirmDelete.warning")}</strong>
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {t("paygap.employeeData.dialog.confirmDelete.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          {t("paygap.employeeData.dialog.confirmDelete.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
